import classNames from 'classnames';
import FreeTextInput from 'components/atoms/Form/FreeTextInput';
import FreeTextInputProps from 'components/atoms/Form/FreeTextInput/FreeTextInput.types';
import type { FC, ReactNode } from 'react';
import { SearchIconOutline, XIcon } from 'utils/icons';

type SearchBarProps = {
  setSearchValue?: (text: string) => void;
  isDisabled?: boolean;
  searchValue?: string;
  placeholder?: string;
  className?: string;
  extra?: ReactNode;
  buttonLabel?: string;
  showController?: boolean;
  inputClassName?: string;
} & Pick<FreeTextInputProps, 'removeLeftRounding' | 'removeRightRounding'>;

const SearchBar: FC<SearchBarProps> = ({
  searchValue,
  isDisabled,
  setSearchValue,
  placeholder,
  className,
  extra,
  inputClassName,
  removeLeftRounding,
  removeRightRounding,
}) => {
  return (
    <div className={classNames('flex', className)}>
      <FreeTextInput
        size="sm"
        wrapperClassName="w-full"
        disabled={isDisabled}
        type="text"
        value={searchValue || ''}
        placeholder={placeholder}
        onChange={(e) => setSearchValue?.(e.target.value)}
        Icon={SearchIconOutline}
        removeLeftRounding={removeLeftRounding}
        removeRightRounding={removeRightRounding}
        className={classNames(inputClassName)}
        renderExtraRight={(className) => {
          if (!searchValue?.trim()) return null;
          return (
            <button
              type="button"
              className={classNames(className)}
              onClick={() => setSearchValue?.('')}
            >
              <XIcon className="w-4 h-4" />
            </button>
          );
        }}
      />
      {extra}
    </div>
  );
};

export default SearchBar;
